import { render } from "./verticalScroll.vue?vue&type=template&id=63de1cb7"
import script from "./verticalScroll.vue?vue&type=script&lang=js"
export * from "./verticalScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__